module.exports = __webpack_public_path__ + "img/actionblue.bef847fc.svg";